<script type="text/ecmascript-6">
    import Layout from '../layouts/MainLayout.vue'
    import {mapGetters} from "vuex";

    export default {
        components: {Layout },

        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isLoading: 'getIsLoading',
                isShow: 'getIsShow',
                isPreview: 'getIsPreview',
                isPrint: 'getIsPrint',
                myApps: 'getMyApps',
                favouriteApp: 'getFavouriteMyApps',
                ownPage: 'getOwnPage',
                dateTime: 'getDateTime',
            })
        },

        methods: {
            deleteMyApp(id) {
                this.$store.dispatch('deleteMyApp',id);
            },

            favouriteMyApp(id, fav) {
                this.$store.dispatch('favouriteMyApp',{id: id, favourite: fav});
            },

            async updateOwnPage(ownPageData) {
                if (ownPageData.id !== this.ownPage.id) {
                    await this.$store.dispatch('setIsLoading',true);
                    await this.$store.dispatch('setOwnPage',ownPageData);
                    await this.getBenchmarkData(this.ownPage);
                    await this.$store.dispatch('setIsLoading',false);
                    await this.$router.push('/dashboard');
                }
            },

            async updateMyProjects() {
                await this.$store.dispatch('setIsLoading',true);
                await this.getMonitoredProfiles();
                await this.$store.dispatch('setIsLoading',false);
                await this.$store.dispatch('setIsShow',true);
            }
        }
    }
</script>

<template>
    <layout>
        <div :class="{'container-fluid' : !isPreview }" v-show="!isLoading">

            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow && favouriteApp.length > 0">
                <div class="card-body">
                    <h2>Favourite Projects</h2>
                    <div class="row mt-3">
                        <div class="col-md-4 mt-3 my-projects" v-for="page in favouriteApp" v-bind:key="page.id" @click.prevent="updateOwnPage(page)">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex flex-row rounded">
                                        <div class="p-0">
                                            <i class="fa fa-5x fa-folder text-primary"></i>
                                        </div>
                                        <div class="pl-3 pt-2 pr-2 pb-2 w-75">
                                            <h5 class="text-black pb-1"><a href="#" @click.prevent="updateOwnPage(page)">{{ page.project_name }}</a></h5>
                                            <i class="fa fa-lg fa-trash-alt pr-3" @click.prevent="deleteMyApp(page.id)"></i>
                                            <i class="fa-lg fa-star" :class="page.favourite ? 'fa text-success' : 'far text-black'" @click.prevent="favouriteMyApp(page.id, !page.favourite)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" :class="[{'mb-3': !isPreview}, {'border-0': isPreview}]" v-show="isShow">
                <div class="card-body">
                    <h2>My Projects</h2>
                    <div class="row mt-3">
                        <div class="col-md-4 mt-3" id="update-my-projects" @click="updateMyProjects()">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex flex-row rounded">
                                        <div class="p-0">
                                            <i class="fa fa-5x fa-folder-plus"></i>
                                        </div>
                                        <div class="pl-3 pr-2 w-75 text-center mb-auto mt-auto">
                                            <h3>Update My Projects</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mt-3 my-projects" v-for="page in myApps" v-bind:key="page.name" @click.prevent="updateOwnPage(page)">
                            <div class="card" :class="{'border-dark' : page.id === ownPage.id}">
                                <div class="card-body">
                                    <div class="d-flex flex-row rounded">
                                        <div class="p-0">
                                            <i class="fa fa-5x fa-folder text-success"></i>
                                        </div>
                                        <div class="pl-3 pt-2 pr-2 pb-2 w-75">
                                            <h5 class="text-black pb-1"><a href="#" @click.prevent="updateOwnPage(page)">{{ page.project_name }}</a></h5>
                                            <i class="fa fa-lg fa-trash-alt pr-3" @click.prevent="deleteMyApp(page.id)"></i>
                                            <i class="fa-lg fa-star" :class="page.favourite ? 'fa text-success' : 'far text-black'" @click.prevent="favouriteMyApp(page.id, !page.favourite)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </layout>
</template>
